import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { Icon } from "../icon/Icon";
import { IdIcon } from "../icon/IdIcon";
export var TextArea = React.memo(function (_a) {
    var value = _a.value, onChange = _a.onChange, style = _a.style, placeholder = _a.placeholder, minLength = _a.minLength, maxLength = _a.maxLength;
    var inputFieldClass = style ? style + " " + IdStyles.TextNormal : IdStyles.TextNormal;
    var onChangeFn = function (text) { return onChange(text); };
    return (React.createElement("div", { className: "text-area w100" },
        React.createElement("textarea", { className: inputFieldClass, value: value, onChange: function (event) { return onChangeFn(event.target.value); }, placeholder: placeholder, minLength: minLength, maxLength: maxLength }),
        React.createElement("div", { className: "text-input__icon" },
            React.createElement(Icon, { icon: IdIcon.PenIcn, styleId: IdStyles.IconSmall }))));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/text-area/TextArea.tsx
// module id = 2621
// module chunks = 3